module.exports = __webpack_public_path__ + "img/pobierz.d038f956.svg";